import type { ReactNode } from 'react';
import { ResultsSort } from '../../shared/results_page/results_sort.js';
import { BUS_RESULTS_ORDERS, type BusResultsOrder } from './bus_results_rules.js';

export type BusResultsSortCopy = {
  sortLabel: string;
  orderLabel(order: BusResultsOrder): string;
};

/** O ordenador do ônibus sobre o `ResultsSort` da casca. */
export function BusResultsSort({
  value,
  copy,
  disabled,
  onChange,
}: {
  readonly value: BusResultsOrder;
  readonly copy: BusResultsSortCopy;
  readonly disabled?: boolean;
  readonly onChange: (order: BusResultsOrder) => void;
}): ReactNode {
  return (
    <ResultsSort
      value={value}
      orders={BUS_RESULTS_ORDERS}
      sortLabel={copy.sortLabel}
      orderLabel={(order) => copy.orderLabel(order)}
      disabled={disabled}
      onChange={onChange}
    />
  );
}
